"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBeforeUnloadReport = void 0;
const react_1 = require("react");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
/**
 * Sends an exercise report via keepalive fetch when the user leaves the page mid-exercise.
 * Skips sending if sendInfoReport was already called (exercise completed normally).
 * The last attempt is tracked as incorrect (user abandoned).
 */
const useBeforeUnloadReport = (getReportData) => {
    const ref = (0, react_1.useRef)(getReportData);
    ref.current = getReportData;
    (0, react_1.useEffect)(() => {
        (0, sendInfoReport_1.resetReportSent)();
        const handler = () => {
            var _a;
            if ((0, sendInfoReport_1.isReportAlreadySent)())
                return;
            const data = ref.current();
            if (!data || !((_a = data.infoRep) === null || _a === void 0 ? void 0 : _a.length))
                return;
            const tracked = (0, sendInfoReport_1.trackAttemptTime)(data.infoRep, false);
            (0, sendInfoReport_1.sendInfoReportBeacon)(tracked, data.exerciseId, window.userId, data.checkedAnswer);
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, []);
};
exports.useBeforeUnloadReport = useBeforeUnloadReport;
